import React, { useContext } from 'react';
// import SearchNocSheets from '../SearchNocSheets';
import SheetDedicatedCustomerTable from './SheetDedicatedCustomerTable';
import AddSheetDedicatedCustomer from './AddSheetDedicatedCustomer';
import PaginatePage from '../common/PaginatePage';
import SheetDedicatedCustomerContext from './context/SheetDedicatedCustomerContext';

const SheetDedicatedCustomerBody = () => {
  const { loading, pages, paginateChange } = useContext(SheetDedicatedCustomerContext);
  return (
    <div className="container">
      <div className="row mt-5">
        {/* <SearchCnMaestro /> */}
        <div className="form-group ml-2">
          <button className="btn btn-green" type="button" data-toggle="modal" data-target="#add-access-point">
            Add Facebook Site
          </button>
        </div>
        <AddSheetDedicatedCustomer />
        <SheetDedicatedCustomerTable />
        {!loading && <PaginatePage pages={pages} paginateChange={paginateChange} />}
      </div>
    </div>
  );
};

export default SheetDedicatedCustomerBody;
